import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
  CognitoUserAttribute
} from 'amazon-cognito-identity-js'
import Config from 'aws-sdk'
import store from '../store'

export default class Cognito {
  configure (config) {
    if (config.userPool) {
      this.userPool = config.userPool
    } else {
      this.userPool = new CognitoUserPool({
        UserPoolId: config.UserPoolId,
        ClientId: config.ClientId
      })
    }
    Config.region = config.region
    this.options = config
    this.currentUser = false
  }

  static install = (Vue, options) => {
    Object.defineProperty(Vue.prototype, '$cognito', {
      get () { return this.$root._cognito }
    })

    Vue.mixin({
      beforeCreate () {
        if (this.$options.cognito) {
          this._cognito = this.$options.cognito
          this._cognito.configure(options)
        }
      }
    })
  }

  /**
   * username, passwordでサインイン
   */
  signin (username, password) {
    const userData = { Username: username, Pool: this.userPool }
    const cognitoUser = new CognitoUser(userData)
    const authenticationData = { Username: username, Password: password }
    const authenticationDetails = new AuthenticationDetails(authenticationData)
    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (result) => {
          // セッションストレージにサインインフラグを格納
          // ブラウザを閉じる/PC再起動をしてもCognitoはクラウド上にある為
          // サインイン状態を維持している。
          // 上記ローカルPC操作時にサインインを無効にするためセッションにフラグを設ける。
          sessionStorage.setItem('signin', '1');
          resolve(result)
        },
        onFailure: (err) => {
          reject(err)
        }
      })
    })
  }

  /**
   * サインアウト
   */
  signout () {
console.log('サインアウト処理');
    if (this.userPool.getCurrentUser()) {
      this.userPool.getCurrentUser().signOut()
    }

    // セッションストレージをクリア
    sessionStorage.removeItem('signin'); // 有：サインイン、無：ブラウザを閉じる/明示的なサインアウト
    sessionStorage.removeItem('search-params-condition'); // 検索条件
    sessionStorage.removeItem('search-result-list'); // 検索結果一覧
  }

  /**
   * 認証済みチェック
   */
  isAuthenticated () {
console.log('認証済みチェック');
//console.log(this.userPool);
    this.currentUser = this.userPool.getCurrentUser()
//console.log(this.currentUser);
    return new Promise((resolve, reject) => {
      // サインインしていない場合（Cognit認証とセッションフラグのどちらかが存在しない）
      // サインイン前(Cognit認証-期限切含)/サインアウト後(両方)/ブラウザを閉じた場合(セッション)
      if (this.currentUser === null || !Object.prototype.hasOwnProperty.call(sessionStorage, 'signin')) {
console.log('サインインチェックエラー');
console.log(this.currentUser);
        reject(this.currentUser);
      } else {

//console.log('getSession');
        // トークンの取得＆期限切れトークンの更新
        this.currentUser.getSession((err, session) => {
          if (err) {
console.log('getSession-error');
            // 更新トークンの期限切れでアクセストークンの更新不可
            console.log(err);
            reject(err)
          } else {
            // 取得失敗-異常
            if (!session.isValid()) {
console.log('更新不可');
              reject(session)
            } else {
console.log('isAuthenticated - 正常取得');
//console.log(session);
              // 正常取得
              resolve(session)
            }
          }
        })
      }
    })
  }

  /**
   * 属性の取得
   */
  getAttribute () {
//console.log('属性の取得');
    return new Promise((resolve, reject) => {
      this.currentUser.getUserAttributes((err, result) => {
        if (err) {
          reject(err)
        } else {
//console.log(result);
          resolve(result)
        }
      })
    })
  }

  /**
   * プロフィール更新
   */
  updateAttributes (attributes) {
console.log("プロフィール更新");
    const attributeList = []
    for(var key in attributes) {
      const attribute = { Name: key, Value: attributes[key] }
      attributeList.push(new CognitoUserAttribute(attribute))
    }
    return new Promise((resolve, reject) => {
      if (this.currentUser === null) { reject(this.currentUser) }

      // update attributes
      this.currentUser.updateAttributes(attributeList, (err, result) => {
        if (err) {
          reject(err)
        } else {
          var user = store.getters.user
          for(var key in attributes) {
            user[key] = attributes[key]
          }
          store.commit('setUser', user)
          resolve(result)
        }
      })
    })
  }
}